import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Auth0ProviderWithNavigate } from "./components/auth0/Auth0ProviderWithNaviagte";
import GlobalErrorBoundary from "./components/common/GlobalErrorBoundary";
import { AxiosProvider } from "./contexts/AxiosContext";
import { BootstrapProvider } from "./contexts/BootstrapContext";
import "./index.css";
import { defaultStaleTime } from "./utils/constants";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: defaultStaleTime,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <QueryClientProvider client={queryClient}>
          <AxiosProvider>
            <BootstrapProvider>
              <GlobalErrorBoundary>
                <App />
              </GlobalErrorBoundary>
            </BootstrapProvider>
          </AxiosProvider>
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition={"bottom-right"}
          />
        </QueryClientProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>
);
